import wirecardPublicKey from './wirecardPublicKey'

export const WEEKDAYS = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']

/**
 * Usa o padrão do Bootstrap:
 * https://getbootstrap.com/docs/4.0/layout/grid/#grid-options
 *
 * sm: 576px
 * md: 768px
 * lg: 992px
 * xl: 1200px
 */
export const MEDIA = {
  TABLET: '(max-width: 1024px)',
  TABLET_UP: '(min-width: 1025px)',
  MOBILE: '(max-width: 575px)',
  MOBILE_UP: '(min-width: 576px)',
  DESKTOP_UP: '(min-width: 1200px)'
}

export const ccList = [
  {
    name: 'Hipercard',
    validator: {
      regex: '^606282|^3841(?:[0|4|6]{1})0',
      mask: '9999999999999999999'
    }
  },
  {
    name: 'American Express',
    validator: {
      regex: '^3[47][0-9]{5,}$',
      mask: '9999 999999 99999'
    }
  },
  {
    name: 'Diners',
    validator: {
      regex: '^3(?:0[0-5]|[68][0-9])[0-9]{4,}$',
      mask: '9999 999999 9999'
    }
  },
  {
    name: 'Elo',
    validator: {
      regex: '^(50(67(0[78]|1[578]|2[012456789]|3[01234569]|4[0134567]|53|7[4-8])|9(0(0[0123478]|14|2[0-3]|3[0359]|4[012356789]|5[1-9]|6[0-9]|7[0134789]|8[04789]|9[123479])|1(0[3458]|4[6-9]|83)|2(20|5[7-9]|6[0-7])|4(0[7-9]|1[0-2]|31|57)|7(22|6[5-9])))|4(0117[89]|3(1274|8935)|5(1416|7(393|63[12])))|6(27780|36368|5(0(0(3[12356789]|4[0-7]|7[78])|4(0[6-9]|1[0-3]|2[4-8]|3[4-9]|8[5-9]|9[0-9])|5(0[012346789]|1[0-9]|2[0-9]|3[0178]|5[2-9]|6[0-4]|7[7-9]|8[0-9]|9[0-8])|72[0-7]|9(0[1-9]|1[0-9]|2[0128]|3[89]|4[6-9]|5[045]|6[25678]|71))|16(5[2-9]|6[0-9]|7[01456789])|50(0[0-9]|1[02345678]|36|5[1267])))\\d{0,13})$',
      mask: '9999 9999 9999 9999'
    }
  },
  {
    name: 'Visa',
    validator: {
      regex: '^4[0-9]{6,}$',
      mask: '9999 9999 9999 9999'
    }
  },
  {
    name: 'Mastercard',
    validator: {
      regex: '^5[1-5][0-9]{5,}|222[1-9][0-9]{3,}|22[3-9][0-9]{4,}|2[3-6][0-9]{5,}|27[01][0-9]{4,}|2720[0-9]{3,}$',
      mask: '9999 9999 9999 9999'
    }
  }
]

// TODO: Subir isso para o back com parametrização no admin
export const installments = {
  maximumQty: process.env.INSTALLMENTS_MAX_QTY,
  minimumPrice: process.env.INSTALLMENTS_MIN_PRICE
}

export const publicKey = wirecardPublicKey

export const featureFlags = {
  enablePackagePurchase: process.env.ENABLE_PACKAGE_PURCHASE !== 'false'
}

export const PET_TYPE = {
  DOG: 'Cachorro',
  CAT: 'Gato',
  FERRET: 'Furão',
  RABBIT: 'Coelho',
  PIGGY_INDIAN: 'Porquinho da Índia'
}

export const DEFAULT_REQUIRED_MESSAGE = 'Campo obrigatório'

export const SCHEDULING_PAY_STATUS = {
  PAYMENT_PENDENT: 'PENDENT', // Agendamento pendente de pagamento
  PAYMENT_PROCESSING: 'PROCESSING', // Agendamento pendente de pagamento
  PAYMENT_BLOCKED: 'BLOCKED', // Pagamento bloqueado por risco
  PAYMENT_CHARGEBACK: 'CHARGEBACK', // Agendamento cancelado com estorno
  PAYMENT_CANCELLED: 'CANCELLED', // Pagamento cancelado
  PAYMENT_PRE_AUTHORIZED: 'PRE_AUTHORIZED', // Pagamento pré-autorizado e pendente de captura
  PAYMENT_NOT_AUTHORIZED: 'NOT_AUTHORIZED', // Pagamento do agendamento não authorizado pela adquirente e antifraude
  PAYMENT_AUTHORIZED: 'AUTHORIZED' // Pagamento do agendamento authorizado pela adquirente e antifraude
}

export const PAGINATION_INITIAL_PAGE = 1
export const PAGINATION_LIMIT = 5
export const PAGINATION_SKIP = 0
